import { generate } from '../../../core/js/utils/componentUtils';
import watch from 'redux-watch';

import template from 'facets/category-facet-header-mobile.j2';

/**
 * Bootstrap the component onto the page
 * @param {object} store - The store
 * @param {object} overrides - The overrides object
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        children: [],
        templateLocation: '.dom-facets-applied-count',
        template: template,
        name: 'mobileFacetCountComponent',
        watch: 'category.facetOptions'
    };

    return generate(config, store, overrides);
}
